<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="132"></ucMenu>
          <div class="right_con">
            <div class="rc_main">

              <div style="display: flex;align-items: center;justify-content: space-between;">
                <p class="fb">检测管理 - 关键词检测记录</p>
                <el-button size="small" type="primary" @click="handleBack">返回</el-button>
              </div>
              <div style="margin-top: 14px">
                <el-form inline size="small">
                  <el-form-item label="状态">
                    <el-select v-model="searchParams.status" clearable placeholder="全部" @change="handleSearch">
                      <el-option v-for="item in Object.keys(statusList)" :key="item" :label="statusList[item].label"
                                 :value="item"></el-option>

                    </el-select>
                  </el-form-item>
                  <el-form-item label="商品分组">
                    <el-select v-model="searchParams.group_id" class="w_120" filterable clearable placeholder="全部" @change="handleSearch">
                      <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-button size="small" @click="handleRefresh"><i class="el-icon-refresh-right el-icon--right"></i>刷新
                  </el-button>
                </el-form>
              </div>
              <el-table v-loading="loading" :data="tableData"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        highlight-current-row row-key="id">
                <el-table-column align="center" label="批次" prop="task_no" width="200px"></el-table-column>
                <el-table-column align="center" label="商品渠道" prop="channel">
                  <template #default="{ row }">
                    <div v-if="row.channel">{{ channeList[row.channel] }}</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="商品分组" prop="channel" show-overflow-tooltip width="200px">
                  <template #default="{ row }">
                    <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                     {{ getGroupNameText(row.group_id, row.child_group_id) }}
                  </template>
                </el-table-column>
                <el-table-column align="center" label="检测分类" prop="channel" show-overflow-tooltip width="200px">
                  <template #default="{ row }">
                    <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                     {{ getLexiconTypeText(row.lexicon_type) }}
                  </template>
                </el-table-column>
                <el-table-column align="center" label="检测方法" prop="detection_method">
                  <template #default="{ row }">
                    <div v-if="row.detection_method">{{ methodList[row.detection_method].label }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="正常/异常" align="center" prop="status" min-width="100px">
                  <template #default="{ row }">
                    <div>{{row.normal_count||0}}/{{row.abnormal_count||0}}</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="状态" prop="status" min-width="80px">
                  <template #default="{ row }">
                    <el-tag :type="statusList[row.status].type" size="small">
                      {{ statusList[row.status].label }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" prop="created_at" min-width="150px"></el-table-column>
                <el-table-column align="center" label="操作" prop="status" min-width="100px">
                  <template #default="{ row }">
                    <el-button size="mini" type="success" @click="openDetail(row)">详情</el-button>
                    <el-button v-if="[1,2].includes(row.status)" size="mini" type="primary" @click="handleStop(row)" style="margin-top: 5px;margin-left: 0;">
                      终止检测
                    </el-button>
                  </template>
                </el-table-column>

              </el-table>

              <Pagination v-if="page_data.total>page_data.limit" :limit.sync="page_data.limit" :page.sync="page_data.page"
                          :total="page_data.total" @pagination="getDataList"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>

    <el-dialog :visible.sync="detailShow" :title="'详情 - '+detailInfo.task_no" width="1350px">
      <div style="display: flex;justify-content: space-between;">
        <!-- detailGroupIds -->
        <el-form inline size="small">
            <el-form-item label="商品分组">
                <el-select v-model="detailGroupIds" clearable multiple collapse-tags placeholder="全部" @change="handleSearchDetail" class="w_220">
                    <el-option v-for="group in search_group" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="检测词分类">
            <!-- <el-select v-model="searchParams.lexicon_type" clearable placeholder="全部" class="w_120">
                <el-option v-for="item in Object.keys(lexiconType)" :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
            </el-select> -->
            <el-select v-model="detailLexiconType" clearable placeholder="全部" class="w_220" multiple collapse-tags @change="handleSearchDetail">
                <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                    <span style="float: left" >{{ item.dictionary_name }}</span>
                    <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                    <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
                </el-option>
            </el-select>
            </el-form-item>
          <el-form-item label="违规词">
            <!-- <el-select v-model="detailStatus" clearable multiple collapse-tags placeholder="全部" @change="handleSearchDetail">
              <el-option v-for="item in Object.keys(detailStatusList)" :key="item" :label="detailStatusList[item]"
                         :value="item"></el-option>
            </el-select> -->
            <el-input v-model="detailWord" placeholder="请输入违规词" @blur="handleSearchDetail" size="small" clearable class="w_140"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="detailStatus" clearable multiple collapse-tags placeholder="全部" @change="handleSearchDetail" class="w_140">
              <el-option v-for="item in Object.keys(detailStatusList)" :key="item" :label="detailStatusList[item]"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作状态">
            <el-select v-model="operStatus" clearable multiple collapse-tags placeholder="全部" @change="handleSearchDetail" class="w_140">
              <el-option v-for="item in Object.keys(operStatusList)" :key="item" :label="operStatusList[item]"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="handleRefreshDetail"><i class="el-icon-refresh-right el-icon--right"></i>刷新
            </el-button>
          </el-form-item>
        </el-form>
    </div>
    <div>
      <el-button type="warning" plain size="small" :disabled="!selectData.length" @click="handleBatch(4)">批量正常</el-button>
      <el-button type="success" plain size="small" :disabled="!selectData.length" @click="handleBatch(2)">批量过滤</el-button>
      <el-button type="primary" plain size="small" :disabled="!selectData.length" @click="handleBatch(3)">批量下架</el-button>
    </div>
      <div style="color: #ed9090;margin-bottom: 8px;">
        未检测 {{countData.untreated_count}}&nbsp;/ 正常 {{countData.normal_count}}&nbsp;/ 异常 {{countData.abnormal_count}}
      </div>

      <el-table v-loading="detailLoading" :data="detailList" max-height="600px" row-key="id"
                @selection-change="selectChange" >
        <el-table-column align="center" type="selection" width="50" :selectable="selectableMethod"></el-table-column>
        <el-table-column align="center" label="商品分组" show-overflow-tooltip width="200px">
            <template #default="{ row }">
            <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                {{ formatGroupName(row) }}
            </template>
        </el-table-column>
        <el-table-column label="标题" align="center" prop="title"></el-table-column>
        <el-table-column label="预计过滤后标题" align="center" prop="replace_title"></el-table-column>
        <el-table-column label="结果反馈" align="center" prop="result_feedback"></el-table-column>
        <el-table-column label="状态" align="center" prop="status" width="80px">
          <template #default="{ row }">
            <el-tag :type="['info','primary','success'][row.status]" size="small">{{ detailStatusList[row.status] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作状态" align="center" prop="status" width="80px">
          <template #default="{ row }">
            <div>{{ operStatusList[row.oper_status] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="created_at" width="100px"></el-table-column>
<!--        <el-table-column label="操作" align="center" prop="status" width="70px">
          <template #default="{ row }">
            <template v-if="row.status==3&&row.oper_status==1">
              <el-button type="text" size="mini" style="color: #0e9f1f">过滤</el-button>
              <el-button type="text" size="mini" style="color: red;margin-left: 0;margin-top: 5px;">下架</el-button>
            </template>
          </template>
        </el-table-column>-->
      </el-table>
      <Pagination v-if="page_data_detail.total>0" :pageSizes = pageSizes :limit.sync="page_data_detail.limit"
                  :page.sync="page_data_detail.page" :total="page_data_detail.total"
                  layout="total, sizes, prev, pager, next, jumper" @pagination="getDetailList" ></Pagination>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions} from "vuex";

import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import Pagination from "@/components/pagination/pagination.vue";

export default {
  name: 'ucenterProductDetails',
  components: {
    Pagination,
    ucMenu,
    myHead,
    myFoot
  },
  data() {
    return {
      pageSizes: [10, 20, 50, 100, 200, 1000, 2000],
      dataInfo: {},
      loading: false,
      tableData: [],
      page_data: {
        limit: 10,
        page: 1,
        total: 0,
      },
      searchParams: {status: '',group_id:''},
      batchId: '',
      statusList: {
        // 0: {label: '手动停止', value: 0, type: 'danger'},
        // 1: {label: '待检测', value: 1, type: 'info'},
        // 2: {label: '检测中', value: 2, type: 'primary'},
        // 3: {label: '已检测', value: 3, type: 'success'},
      },
      channeList: {
        // 1: {label: '云商品库'},
        // 2: {label: '草稿箱'},
        // 3: {label: '仓库中'},
        // 4: {label: '上架中'},
      },
      methodList: {
        1: {label: '全量检测'},
        2: {label: '未检测数据'},
      },

      detailInfo: {},
      detailShow: false,
      detailList: [],
      detailLoading: false,
      page_data_detail: {
        limit: 10,
        page: 1,
        total: 0,
      },
      detailStatus: '',
      detailWord: '',
      detailGroupIds: [],
      detailLexiconType: [],
      search_group:[],
      detailStatusList: {
        // 1: {label: '待检测', value: 1, type: 'info'},
        // 2: {label: '正常', value: 2, type: 'primary'},
        // 3: {label: '异常', value: 3, type: 'success'},
      },
      operStatus:'',
      operStatusList:[],
      selectData: [],
      countData:{},
      groupList:[],
      groupObj:{},
      dictionaryWordsList:[],
    }
  },
  created() {
    this.getDataList()
    this.getGroupList()
    this.getDictionaryWords()
  },

  methods: {
    ...mapActions({
      getDetectionList: 'ucenter/getDetectionList',
      opStopDetection: 'ucenter/opStopDetection',
      getDetectionItemList: 'ucenter/getDetectionItemList',
      opDetectionBatchOperation: 'ucenter/opDetectionBatchOperation',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
    }),
    handleBack() {
      this.$router.back()
    },
    //===获取列表===
    getDataList() {
      this.loading = true
      let param = {
        page_size: this.page_data.limit,
        page: this.page_data.page,
        batch_id: this.batchId, ...this.searchParams
      }
      this.getDetectionList({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
            this.channeList=res.data.channel_filter
            this.statusList={}
            const type=['danger','info','primary','success']
              res.data.status_filter.forEach((item,index)=>{
                this.statusList[index]={label:item,value:index,type:type[index]||'info'}
              })
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    handleSearch() {
      this.page_data.page = 1
      this.getDataList()
    },
    handleRefresh(){
      this.searchParams={status: '',group_id:''}
      this.handleSearch()
    },
    // 获取分组列表
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || []
            this.groupObj={}
            this.groupList.forEach(item=>{
              this.groupObj[item.id]=item.name
            })
          }
        }
      })
    },
    getDictionaryWords() {
      this.opGetDictionaryWords({
        data: {'dictionary_type': 1},
        success: (res) => {
          if (res.code == 200) {
            this.dictionaryWordsList = res.data || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // === 查看详情 ===
    openDetail(row) {
      if(!row.group_id || (Array.isArray(row.group_id) && row.group_id.length === 0)) {
        this.search_group = this.groupList
      } else {
        this.search_group = this.groupList.filter(item =>row.group_id.includes(item.id))
      }
      this.detailGroupIds = []
      this.detailStatus = []
      this.detailLexiconType = []
      this.detailWord = ''
      this.detailInfo = {id:row.id,task_no:row.task_no}
      this.detailShow = true
      this.detailList =[]
      this.page_data_detail= { limit: 10, page: 1, total: 0 }
      this.getDetailList()
    },
    getDetailList() {
      const params = {
        id: this.detailInfo.id,
        page_size: this.page_data_detail.limit,
        page: this.page_data_detail.page,
        status: this.detailStatus,
        keyword: this.detailWord,
        groupIds: this.detailGroupIds,
        lexicon_types: this.detailLexiconType,
        oper_status: this.operStatus
      }
      this.detailLoading = true
      this.getDetectionItemList({
        data: params,
        success: (res) => {
          this.detailLoading = false
          if (res.code == 200) {
            this.detailList = res.data.list
            this.page_data_detail.total = res.data.total
            this.operStatusList = res.data.oper_status_filter
            this.detailStatusList = res.data.status_filter
            this.countData={
              untreated_count: res.data.untreated_count||0,
              normal_count: res.data.normal_count||0,
              abnormal_count: res.data.abnormal_count||0,
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleSearchDetail() {
      this.page_data_detail.page = 1
      this.getDetailList()
    },
    handleRefreshDetail(){
      this.detailStatus=''
      this.handleSearchDetail()
    },
    selectChange(val) {
      this.selectData = val
    },
    selectableMethod(row){
      return row.status==3&&row.oper_status==1
    },

    // === 终止检测 ===
    handleStop(row) {
      this.$confirm('确定要终止检测吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opStopDetection({
          data: {id: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('终止成功')
            } else {
              this.$message.error(res.message)
            }
            this.getDataList()
          }
        })
      })
    },
    //批量操作
    handleBatch(type) {
      const typeText = ['', '', '过滤', '下架', '正常']; // type=0/1 → 下架，type=2 → 过滤
      this.$confirm(`确定要批量${typeText[type]}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opDetectionBatchOperation({
          data: {
            ids: this.selectData.map(item => item.id).join(','),
            oper_type: type
          },
          success: (res) => {
            if (res.code == 200) {
              this.$message.success(`${type==2?'过滤':'下架'}成功`)
              this.getDetailList()
            }
          }
        })
      })
    },
    getGroupNameText(groupId, child_group_ids, flag = 0) {
        if (!groupId && flag === 0) return '全部'
        let ids = []
        if (typeof groupId === 'string') {
            try {
                ids = JSON.parse(groupId)
            } catch (e) {
                ids = groupId.split(',').map(item => item.trim())
            }
        } else {
            ids = Array.isArray(groupId) ? groupId : [groupId]
        }

        // 统一处理 child_group_ids 为数组
        let childIds = []
        if (typeof child_group_ids === 'string') {
            try {
                childIds = JSON.parse(child_group_ids)
            } catch (e) {
                childIds = child_group_ids.split(',').map(item => item.trim())
            }
        } else {
            childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
        }

        return ids.filter(id => id) // 去掉空ID
            .map(id => this.groupList.find(item => item.id === id)) // 用ID匹配数组
            .filter(Boolean) // 过滤找不到的
            .map(item => {
                let name = item.name
                // 判断 item.child_groups 是否有值，并筛选出 id 存在于 child_group_ids 中的子分组
                if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
                    const matchedChildNames = item.child_groups
                        .filter(child => childIds.includes(child.id))
                        .map(child => child.name)
                    // 如果有匹配的子分组，则用括号拼接展示
                    if (matchedChildNames.length > 0) {
                        name += `（${matchedChildNames.join('、')}）`
                    }
                }
                return name
            })
            .join('、')
    },
    getLexiconTypeText(lexiconType) {
        if (!lexiconType) return '全部'
        let ids = []
        if (typeof lexiconType === 'string') {
            try {
                ids = JSON.parse(lexiconType)
            } catch (e) {
                ids = lexiconType.split(',').map(item => item.trim())
            }
        } else {
            ids = Array.isArray(lexiconType) ? lexiconType : [lexiconType]
        }

        // 2. 过滤 + 匹配名称
        const words_type =  ids.map(id => {
                const item = this.dictionaryWordsList.find(obj => obj.id == id)
                return item ? item.dictionary_name : ''
            })
            .filter(Boolean)
            .join('、')
        return words_type;
    },
    formatGroupName(row) {
        let group_id = row?.productimport?.group_id || '-'
        let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
        let child_group_id = row?.productimport?.child_group_id || '-'
        const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
        const child_group_name = target?.name || null
        if(child_group_name) {
            group_name += '|'+child_group_name
        }
        return group_name;
    },

  }
}
</script>


<style scoped>

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  min-height: 500px;
}

.rc_table {
  width: 100%;
  /* margin-top: 20px;*/
}

.rc_main {
  padding: 36px 40px 46px;
}

.goods-box {
  display: flex;
  line-height: 16px;
  font-size: 14px;
}

.goods-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 5px;
}

.goods-info {
  flex: 1;
}

.goods-info div ~ div {
  margin-top: 4px;
}
.w_140 {
  width: 140px;
}
</style>
